import{isScope as e,stringifyScope as t}from"@nohara-dxdev/roles";const n=async(n,r=``,i)=>{let{data:a}=await n.get(`/roles`,{params:e(r)?{scope:t(r),...i}:i});return a};export{n as getRoles};
//# sourceMappingURL=get-roles.mjs.map